class ProductCardS1 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange({ target }) {
    const optionElement = target.options[target.selectedIndex];
    this.toggleImage(optionElement);
    this.toggleAddButton(true);
    fetch(`${this.dataset.url}?variant=${target.value}&section_id=card-product-s1`).then((response) => response.text()).then((responseText) => {
      var _a;
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const priceElement = this.querySelector(".sm-product-card-s1__price");
      const replacePriceHtml = ((_a = html.querySelector(".sm-product-card-s1__price")) == null ? void 0 : _a.innerHTML) || "";
      if (priceElement && replacePriceHtml) {
        priceElement.innerHTML = replacePriceHtml;
      }
    }).catch((error) => {
      console.error("An error occurred in the function onSelectChange", error);
    }).finally(() => {
      this.toggleAddButton(false);
    });
  }
  toggleImage(optionElement) {
    var _a;
    const mediaElement = this.querySelector(".sm-card-s1__media-img img");
    if (optionElement && mediaElement) {
      const src = mediaElement.getAttribute("src") || "";
      const oldSrc = src.split("?")[0] || "";
      const newSrc = ((_a = optionElement.dataset.src) == null ? void 0 : _a.split("?")[0]) || "";
      const setSrc = src.replace(oldSrc, newSrc);
      const oldSrcset = mediaElement.getAttribute("srcset") || "";
      const setSrcset = oldSrcset.replace(new RegExp(oldSrc, "g"), newSrc);
      mediaElement.setAttribute("src", setSrc);
      mediaElement.setAttribute("srcset", setSrcset);
    }
  }
  toggleAddButton(disabled = false) {
    const addButton = this.querySelector('button[name="add"]');
    if (disabled) {
      addButton.setAttribute("disabled", disabled);
    } else {
      addButton.removeAttribute("disabled");
    }
  }
}
customElements.define("product-card-s1", ProductCardS1);
